import { createClient } from '@supabase/supabase-js'

// Use local Supabase in development if REACT_APP_USE_LOCAL_SUPABASE is set to 'true'
// Otherwise, use the production Supabase credentials
const isLocal = process.env.REACT_APP_USE_LOCAL_SUPABASE === 'true'

const supabaseUrl = isLocal
  ? process.env.REACT_APP_SUPABASE_LOCAL_URL || 'http://127.0.0.1:54321'
  : process.env.REACT_APP_SUPABASE_URL

const supabaseKey = isLocal
  ? process.env.REACT_APP_SUPABASE_LOCAL_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0'
  : process.env.REACT_APP_SUPABASE_KEY

const supabase = createClient(supabaseUrl, supabaseKey)

export default supabase
